import React, { Component } from 'react'

// import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { filterCaseInsensitive } from '../../../util'
import { Tooltip } from 'antd'

import * as testingSelectors from '../../../selectors/job/testing'
import { actions as testingActions } from '../../../redux/modules/jobFunctions/testingActions'
import { actions as revisionActions } from '../../../redux/modules//revisionActions'

import AddEditModal from '../../../components/jobs/testing/AddEditModal'

const propTypes = {
  testingItems: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  jobId: PropTypes.string.isRequired,

  // actions
  fetchTesting: PropTypes.func.isRequired,
  createTesting: PropTypes.func.isRequired,
  updateTesting: PropTypes.func.isRequired,
  fetchTestingAttachments: PropTypes.func.isRequired,
  getRevisions: PropTypes.func.isRequired
}

class Testing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      selectedTesting: null
    }
  }

  componentDidMount() {
    const { fetchTesting, jobId } = this.props
    fetchTesting(jobId)
  }

  hangleToggleModal = () => {
    const { isModalOpen } = this.state

    this.setState({
      isModalOpen: !isModalOpen
    })
  }

  handleAddButton = () => {
    this.setState(
      {
        selectedTesting: null
      },
      () => this.hangleToggleModal()
    )
  }

  handleCreateTesting = formData => {
    const { createTesting, jobId } = this.props
    createTesting(jobId, formData)
    this.hangleToggleModal()
  }

  handleUpdateTesting = formData => {
    const { updateTesting, jobId } = this.props
    const { selectedTesting } = this.state
    updateTesting(selectedTesting.id, jobId, formData)
    this.hangleToggleModal()
  }

  handleDeleteTesting = testingId => {
    const { deleteTesting, jobId } = this.props
    deleteTesting(testingId, jobId)
    this.hangleToggleModal()
  }

  handleRowClick = row => {
    const { fetchTestingAttachments, getRevisions } = this.props
    this.setState({ selectedTesting: row }, () => {
      fetchTestingAttachments(row.id)
      getRevisions({ targetId: row.id, table: 'testing' })
      this.hangleToggleModal()
    })
  }

  updateSelectedTesting = selectedTesting => {
    this.setState({
      selectedTesting: selectedTesting
    })
  }

  render() {
    const { loading, testingItems } = this.props
    const { selectedTesting, isModalOpen } = this.state

    return (
      <div>
        <AddEditModal
          selectedTesting={selectedTesting}
          isModalOpen={isModalOpen}
          handleCancel={this.hangleToggleModal}
          createTesting={this.handleCreateTesting}
          updateTesting={this.handleUpdateTesting}
          deleteTesting={this.handleDeleteTesting}
          updateSelectedTesting={this.updateSelectedTesting}
        />
        <div className="jobsBar">
          Testing
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Test
            </div>
          </div>
        </div>

        <ReactTable
          filterable
          loading={loading}
          defaultFilterMethod={filterCaseInsensitive}
          getTdProps={(state, rowInfo, column, instance) => ({
            onClick: e => {
              if (column.Header !== undefined) {
                this.handleRowClick(rowInfo.original)
              }
            }
          })}
          data={testingItems}
          columns={[
            {
              columns: [
                {
                  Header: '#',
                  id: 'id',
                  accessor: 'id',
                  Cell: d => <Tooltip title={d.original.id}>{d.original.id}</Tooltip>,
                  maxWidth: 80
                },
                {
                  Header: 'Name',
                  id: 'name',
                  accessor: 'name',
                  Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                },
                {
                  Header: 'Category',
                  id: 'category',
                  accessor: 'category',
                  Cell: d => <Tooltip title={d.original.category}>{d.original.category}</Tooltip>
                },
                {
                  Header: 'Created Date',
                  id: 'created_date',
                  accessor: d => moment(d.created_date).format('M/D/YYYY')
                }
              ]
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  testingItems: testingSelectors.getTestingItems(state, props),
  loading: testingSelectors.getItemsLoading(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  fetchTesting: jobId => dispatch(testingActions.fetchTesting(jobId)),
  createTesting: (jobId, formData) => dispatch(testingActions.createTesting(jobId, formData)),
  updateTesting: (testingId, jobId, formData) =>
    dispatch(testingActions.updateTesting(testingId, jobId, formData)),
  deleteTesting: (testingId, jobId) => dispatch(testingActions.deleteTesting(testingId, jobId)),
  fetchTestingAttachments: testingId => dispatch(testingActions.fetchTestingAttachments(testingId)),
  getRevisions: ({ targetId, table }) => dispatch(revisionActions.getRevisions({ targetId, table }))
})

Testing.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Testing))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/Testing.js